import loadBlocks from './blocks';

export const flexBoxPlugin = (editor, config = {}) => {
  // Default options
  let defaults = {
    // Use this to extend the default flexbox block
    flexboxBlock: {},

    // Classes prefix
    stylePrefix: '',

    // Row label
    labelRow: 'Row',

    // Column label
    labelColumn: 'Column',

    addMediaQueries: true
  };

  const opts = { ...defaults, ...config };

  // Add blocks
  loadBlocks(editor, opts);
};
